/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSystemFeatureStatusViewModel } from '../../models/client-system-feature-status-view-model';

export interface SaveClientSystemFeatureStatus$Params {
  clientID: number;
      body?: ClientSystemFeatureStatusViewModel
}

export function SaveClientSystemFeatureStatus(http: HttpClient, rootUrl: string, params: SaveClientSystemFeatureStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSystemFeatureStatusViewModel>> {
  const rb = new RequestBuilder(rootUrl, SaveClientSystemFeatureStatus.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSystemFeatureStatusViewModel>;
    })
  );
}

SaveClientSystemFeatureStatus.PATH = '/api/Clients/SaveClientSystemFeatureStatus/{clientID}';
